import type {WrappedSectionItem} from './types';

export enum Position {
  TOP = `top`,
  BOTTOM = `bottom`,
  LEFT = `left`,
  RIGHT = `right`,
}

export const SHOW_ALL_ITEM = {
  icon: `caret-down`,
  isExpander: true,
  label: `Show all`,
};

export const SELECT_ALL_ITEM = {
  isSelectAll: true,
  label: `Select all`,
  searchable: false,
};

export const SELECT_ALL_MATCHING_ITEM = {
  isSelectAllMatching: true,
  label: `Select all matching`,
  searchable: false,
};

export const MAX_CSV_MATCHES = 5000;

export const PROGRESSIVE_SIZE = 100; // Render 100 items at first, as user scrolls, render more items as needed

export const WrappedSectionItemKeys: Array<keyof WrappedSectionItem> = [
  `index`,
  `labelMatch`,
  `subLabelMatch`,
  `wrapped`,
];

export enum SelectionState {
  All = `all`,
  Some = `some`,
  None = `none`,
}
